import { useCallback, useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Portfolio from './pages/Portfolio'
import Header from './components/Header'
import Contact from './components/Contact'
import Preloader from './components/Preloader'
import { startSmoothScroll } from './lib/scroll'

// Greeting runs once per session, on the home page, and never for reduced motion.
function shouldPreload() {
  if (location.pathname !== '/' || location.hash) return false
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return false
  try {
    if (sessionStorage.getItem('greeted')) return false
    sessionStorage.setItem('greeted', '1')
  } catch {
    // storage blocked: still fine to greet
  }
  return true
}

// Module scope, not a useState initializer: StrictMode runs initializers twice,
// and the second run would see the flag the first one just set.
const greet = shouldPreload()

function Site() {
  const [loading, setLoading] = useState(greet)
  const done = useCallback(() => setLoading(false), [])

  const [theme, setTheme] = useState(() =>
    document.documentElement.classList.contains('dark') ? 'dark' : 'light',
  )
  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark'
    document.documentElement.classList.toggle('dark', next === 'dark')
    try {
      localStorage.setItem('theme', next)
    } catch {
      // not persisted; theme still switches for this visit
    }
    setTheme(next)
  }

  useEffect(startSmoothScroll, [])

  return (
    <>
      <a href='#main' className='btn sr-only z-50 focus:not-sr-only focus:fixed focus:left-4 focus:top-4'>
        Skip to content
      </a>
      {loading && <Preloader onDone={done} />}
      <Header theme={theme} toggleTheme={toggleTheme} />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/about' element={<Navigate to='/#about' replace />} />
        <Route path='/contacts' element={<Navigate to='/#contact' replace />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
      <Contact />
    </>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Site />
    </BrowserRouter>
  )
}

export default App
